import { useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import Select from "react-select";

function InstallationModal({ saveLocation, ghl_locations, edit_data, DeleteNewLevel }) {
    const [open, setOpen] = useState(false)
    const [refresh, setrefresh] = useState(false);
    const [selectedLocations, setSelectedLocations] = useState(edit_data?.locations || [""]);

    const removeLocation = (Index) => {
        console.log(Index, 'Index')
        const data = selectedLocations
        console.log(data, 'data')
        data.splice(Index, 1);
        console.log(data, 'splicedata')

        setSelectedLocations(data);
        setrefresh(!refresh)
    };
    const editLocation = (Index, value) => {
        const data = selectedLocations

        data[Index] = value;
        setSelectedLocations(data);
        setrefresh(!refresh)

    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const locationsWithIds = {
            ...edit_data,
            name: e.target.name.value,
            enable_menu_edits: e.target.enable_menu_edits.checked,
            locations: selectedLocations,
            _id: edit_data._id
        };
        console.log("Locations with IDs:", locationsWithIds);
        saveLocation(locationsWithIds);
        setSelectedLocations([]);
        handleClose()
    };

    const handleClose = () => {
        setOpen(false)
    }
    return (
        <>
            <div >

                <i className="ri-edit-2-fill" style={{ cursor: 'pointer' }} onClick={() => setOpen(true)}></i>
                <i className="ri-delete-bin-6-fill " style={{ cursor: 'pointer', marginLeft: "10px" }} onClick={DeleteNewLevel}></i>
            </div>

            {/* <Button variant="primary" onClick={() => setOpen(true)}>
                Edit
            </Button> */}
            <Modal show={open} onHide={handleClose} centered>
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Group</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3" controlId="formLocationID">
                            <Form.Label>Group Name</Form.Label>
                            <Form.Control
                                defaultValue={edit_data?.name}
                                type="text"
                                placeholder="Enter Location Name"
                                name="name"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formLocationID">
                            <Form.Label>Locations</Form.Label>
                            <Select defaultValue={edit_data?.locations} options={ghl_locations} isSearchable={false} isMulti onChange={(e) => setSelectedLocations(e)} />
                            {/* {
                                selectedLocations.map((location, index) =>
                                    <>
                                        <div className="d-flex gap-2 align-items-center">

                                            <Form.Control
                                                className="mb-2"
                                                type="text"
                                                placeholder="Enter Location ID"
                                                name="location_id"
                                                value={location}
                                                onChange={(e) => editLocation(index, e.target.value)}
                                            />
                                            <span style={{ cursor: 'pointer', fontSize: '18px' }}
                                                onClick={() => removeLocation(index)}
                                            ><i className="ri-close-circle-line"></i>
                                            </span>
                                        </div>
                                    </>
                                )
                            }
                            <div className="d-flex justify-content-start mt-2">

                                <Button variant="primary" type="button" onClick={() => setSelectedLocations([...selectedLocations, ''])}>
                                    + Add Location Id
                                </Button>
                            </div> */}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formLink">
                            <Form.Check
                                defaultChecked={edit_data?.enable_menu_edits}
                                type="checkbox"
                                label="Enable Menu Edits"
                                name="enable_menu_edits"
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" type="submit">
                            Edit
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}
export default InstallationModal